import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { GoAlertFill } from "react-icons/go";
import axios from "axios";
import { Link } from "react-router-dom";
import { Loader } from "../../constance";
import { search } from "../../assets";
import _ from "lodash";

const Products = () => {
  const [products, SetProducts] = useState([]);
  const [id, setId] = useState(null);
  const [dailog, setDailog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get("/products")
      .then((response) => {
        SetProducts(response.data);
        setLoading(false);
        setDeleteId(false);
      })
      .catch((err) => console.log(err));
  }, [deleteId]);

  const handleDelete = (id) => {
    setLoading(true);
    axios.delete("/products/" + id).then((res) => {
      SetProducts(products.filter((item) => item.id !== id));
      setLoading(false);
      setDeleteId(true);
    });
  };
  return (
    <div>
      <div className="container mx-auto mt-36 min-h-screen">
        {loading && <Loader loading={loading} />}
        <div className="flex flex-row justify-between items-center my-10">
          <div className="w-1/3">
            <h4 className="text-primary md:text-[40px] text-lg"> Products</h4>
          </div>
          <div className="w-2/3 items-center ">
            <form className="flex justify-center w-full">
              <div className="relative w-full md:w-[28rem]">
                <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                  <img src={search} alt="search" className="w-5 left-0" />
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block w-full py-2 px-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-full bg-gray-50"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </form>
          </div>
        </div>
        {products?.length === 0 && !loading && (
          <div className="text-2xl text-center my-20 text-primary font-semibold">
            No Products Found !
          </div>
        )}
        {products?.length !== 0 && !loading && (
          <>
            <div className="flex flex-row mt-10 justify-between border border-primary rounded-t-lg items-center text-white text-[20px] bg-primary py-2 px-6 overflow-x-auto">
              {/* <div className="w-full">Products</div> */}
              <p className="text-[20px] md:w-[60%]">Product Title</p>
              <div className="md:w-[20%] flex flex-row justify-between items-center">
                <p className="text-[20px] hidden md:block ml-2">Edit</p>
                <p className="text-[20px]  hidden md:block">Delete</p>
              </div>
            </div>
            <div className="flex flex-col border border-primary mb-10 rounded-b-lg overflow-x-auto">
              {products?.filter((item) =>
                _.includes(item.title.toLowerCase(), searchTerm.toLowerCase())
              ).length === 0 ? (
                <div className="text-lg text-center my-5 ">
                  No Products found !
                </div>
              ) : (
                <div className="flex flex-col overflow-x-auto ">
                  {products
                    ?.filter((item) =>
                      _.includes(
                        item.title.toLowerCase(),
                        searchTerm.toLowerCase()
                      )
                    )
                    ?.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-row justify-between rounded-t-lg items-center text-black border-b py-2 px-6"
                      >
                        <p className="text-[17px] w-[60%]">
                          {index + 1}. {item?.title}
                        </p>
                        <div className="w-[20%] flex flex-row justify-between items-center">
                          <Link to={`/admin/${item?._id}`}>
                            <button
                              className="font-bold py-2 px-4 rounded"
                              onClick={() => {
                                setId(item?._id);
                              }}
                            >
                              <FaEdit className="text-xl text-[#49A94D]" />
                            </button>
                          </Link>

                          <button
                            className="font-bold py-2 px-4 rounded"
                            onClick={() => {
                              setDailog(true);
                              setId(item?._id);
                            }}
                          >
                            <MdDelete className="text-xl text-red-500" />
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {dailog && (
        <div
          id="modelConfirm"
          className="fixed  z-50 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full px-4 "
        >
          <div className="relative top-40 mx-auto shadow-xl rounded-md bg-white max-w-md">
            <div className="flex justify-end pr-4 pt-4">
              <IoMdClose
                className="text-2xl text-third"
                onClick={() => setDailog(false)}
              />
            </div>

            <div className="p-6 pt-0 text-center items-center flex justify-center flex-col">
              <GoAlertFill className="text-2xl text-red-500 " />

              <h3 className="text-lg font-normal text-secondary mt-5 mb-6 capitalize">
                Are you sure you want to delete?
              </h3>
              <div className="flex flex-row items-center gap-4">
                <button
                  href="#"
                  onClick={() => {
                    handleDelete(id);
                    setDailog(false);
                  }}
                  className="text-white bg-primary font-medium rounded-full  inline-flex items-center px-8 py-1.5 text-smtext-center mr-2"
                >
                  Yes
                </button>
                <button
                  href="#"
                  onClick={() => {
                    setDailog(false);
                  }}
                  className=" bg-white border-2 border-primary font-medium inline-flex items-center rounded-full px-8 py-1 text-center"
                  data-modal-toggle="delete-user-modal"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
